export const now = (): ISOString => new Date().toISOString();
